export const carouselData = [
  {
    id: 1,
    desc: `A magical wand powered by AR that unlocks the barriers
            of your phone's screen so that you can create,
            collaborate and transform the world by drawing.`,
    team: 'Team AR Wand',
    teamDesc: 'Best Overall Hack, WTH2018',
    teamURL: '',
    teamVideoURL: '',
  },
  {
    id: 2,
    desc: `A seriously-cool plasma ion rocket thruster that
            uses high currents and pressures to create thrust
            via the dissociation of argon electrons.`,
    team: 'Team Duct Tape Hax',
    teamDesc: 'Best Space Hack, WTH2017',
    teamURL: '',
    teamVideoURL: '',
  },
  {
    id: 3,
    desc: `An entertaining VR tower defense game that teaches
            you the fundamental concepts of circuit physics
            as you defend against hordes of feisty zombies.`,
    team: 'Team Circuit Defense',
    teamDesc: 'Best VR Hack, WTH2018',
    teamURL: '',
    teamVideoURL: '',
  },
  {
    id: 4,
    desc: `A smart bin that classifies waste into different
            material categories for recycling purposes, and
            then credits you with EZ-Link credits for the job
            well done!`,
    team: 'Team Sentinel',
    teamDesc: 'WTH2017',
    teamURL: '',
    teamVideoURL: '',
  },
  {
    id: 5,
    desc: `An immersive and educational VR simulation of a
            fire incident in an office where you have to use
            the right tools and find the right path to escape.`,
    team: 'Team Fire Escape',
    teamDesc: 'WTH2018',
    teamURL: '',
    teamVideoURL: '',
  },
];
